import { __assign } from "tslib";
import * as React from 'react';
export * from './colorUtils';
export * from './schemaUtils';
export * from './styledUtils';
var matchOperatorsRe = /[|\\{}()[\]^$+*?.]/g;
export var hashCode = function (text, max) {
    var hash = 0;
    for (var index = 0; index < text.length; index++) {
        hash = text.charCodeAt(index) + ((hash << 5) - hash);
    }
    return (hash >> (text.length * 8)) & max;
};
export var randomString = function (length) {
    if (length === void 0) { length = 16; }
    var text = '';
    var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (var i = 0; i < length; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
};
export var regexEscape = function (str) {
    return str.replace(matchOperatorsRe, '\\$&');
};
export var withConditional = function (hoc, fn) {
    return function (Base) {
        var Wrapped = hoc(Base);
        return React.forwardRef(function (props, ref) {
            var Component = fn(props) ? Wrapped : Base;
            return React.createElement(Component, __assign(__assign({}, props), { ref: ref }));
        });
    };
};
export var stopEvent = function (event) {
    event.preventDefault();
    event.stopPropagation();
};
export var stopKeyDownEvent = function (e, keyCode, handler) {
    if (!e.defaultPrevented && e.keyCode === keyCode) {
        e.preventDefault();
        e.stopPropagation();
        if (handler) {
            handler();
        }
    }
};
export var withPreventDefault = function (fn) { return function (e) {
    if (e && e.preventDefault) {
        e.preventDefault();
    }
    return fn();
}; };
export var getFromLocalStorage = function (key) {
    try {
        var val = localStorage.getItem(key);
        if (val != null) {
            return JSON.parse(val);
        }
        return undefined;
    }
    catch (err) {
        console.error(err);
        return undefined;
    }
};
export var setToLocalStorage = function (key, value) {
    try {
        localStorage.setItem(key, JSON.stringify(value));
    }
    catch (err) {
        console.error(err);
    }
};
export var removeFromLocalStorage = function (key) {
    try {
        localStorage.removeItem(key);
    }
    catch (err) {
        console.error(err);
    }
};
